import { createContext, useContext } from 'react'
import type { useVibeAgent } from '../use-vibe-agent'

/**
 * `useVibeAgent()` owns mount rehydration and the single stream viewer, so it must
 * run exactly once per sidebar. The chat root calls it and shares the returned
 * methods through this context; deep children (input, approval, question card)
 * read them here instead of each re-invoking the hook.
 */
export type VibeAgentApi = ReturnType<typeof useVibeAgent>

const VibeAgentApiContext = createContext<VibeAgentApi | null>(null)

export const VibeAgentApiProvider = VibeAgentApiContext.Provider

export const useVibeAgentApi = (): VibeAgentApi => {
  const api = useContext(VibeAgentApiContext)
  if (!api) throw new Error('useVibeAgentApi must be used within VibeAgentApiProvider')
  return api
}
